import { TopBar } from 'shared-ui';
import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;

  padding-bottom: 12px;
`;

export const TopBarWrapper = styled(TopBar)`
  padding-bottom: 12px;
`;
